import { css } from '@emotion/core';
import { colors } from './Colors';

const GlobalStyle = css`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html,
  body {
    height: 100%;
    color: ${colors.textColor};
    background-color: ${colors.backgroundLight};
    cursor: default;
  }

  html {
    font-size: 10px;
    font-family: Ubuntu, sans-serif;
    text-rendering: optimizeSpeed;
    min-width: 320px;
    -webkit-text-size-adjust: none;
  }

  @media (max-width: 1441px) {
    html {
      font-size: calc((10px + ((100vw - 1440px) / 1440) * 10));
    }
  }

  .fade-appear,
  .fade-enter {
    opacity: 0;
  }
  .fade-appear-active,
  .fade-enter-active,
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
  }
  .fade-enter-active,
  .fade-exit-active,
  .fade-appear-active {
    transition: opacity 300ms;
  }

  @media screen and (max-width: 769px) {
    html {
      font-size: 62.5%;
    }
  }

  /* Global classes */

  /* safari ios changing color of phone number */
  a[href^='tel'] {
    text-decoration: inherit;
    color: inherit;
  }

  /* safari */
  .prevent-scroll {
    height: 100vh;
    width: 100vw;
    position: fixed;
    overflow-y: hidden;
    /* -webkit-overflow-scrolling: touch; */
  }

  button {
    border: none;
    background: none;
  }

  button :hover,
  button :focus {
    outline: none;
  }

  button :hover,
  button :focus,
  a :hover,
  a :focus,
  .hoverable,
  .hoverable :hover {
    cursor: pointer;
    font-family: Ubuntu, sans-serif;
  }
  /*---------------------------------------*/
  /*! locomotive-scroll v4.0.3 | MIT License | https://github.com/locomotivemtl/locomotive-scroll */
  html.has-scroll-smooth {
    overflow: hidden;
  }

  html.has-scroll-dragging {
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .has-scroll-smooth body {
    overflow: hidden;
  }

  .has-scroll-smooth [data-scroll-container] {
    min-height: 100vh;
  }

  [data-scroll-direction='horizontal'] [data-scroll-container] {
    white-space: nowrap;
    height: 100vh;
    display: inline-block;
    white-space: nowrap;
  }

  [data-scroll-direction='horizontal'] [data-scroll-section] {
    display: inline-block;
    vertical-align: top;
    white-space: nowrap;
    height: 100%;
  }

  .c-scrollbar {
    position: absolute;
    right: 0;
    top: 0;
    width: 11px;
    height: 100%;
    transform-origin: center right;
    transition: transform 0.3s, opacity 0.3s;
    opacity: 0;
  }
  .c-scrollbar:hover {
    transform: scaleX(1.45);
  }
  .c-scrollbar:hover,
  .has-scroll-scrolling .c-scrollbar,
  .has-scroll-dragging .c-scrollbar {
    opacity: 1;
  }
  [data-scroll-direction='horizontal'] .c-scrollbar {
    width: 100%;
    height: 10px;
    top: auto;
    bottom: 0;
    transform: scaleY(1);
  }
  [data-scroll-direction='horizontal'] .c-scrollbar:hover {
    transform: scaleY(1.3);
  }

  .c-scrollbar_thumb {
    position: absolute;
    top: 0;
    right: 0;
    background-color: black;
    opacity: 0.5;
    width: 7px;
    border-radius: 10px;
    margin: 2px;
    cursor: -webkit-grab;
    cursor: grab;
  }
  .has-scroll-dragging .c-scrollbar_thumb {
    cursor: -webkit-grabbing;
    cursor: grabbing;
  }
  [data-scroll-direction='horizontal'] .c-scrollbar_thumb {
    right: auto;
    bottom: 0;
  }
`;

export default GlobalStyle;
